// extracted by mini-css-extract-plugin
export default {"title":"Logout_title__46Bun"};